module.exports = __webpack_public_path__ + "static/storage-base-intro-1-5c31d9a8f2956299ca80e2ed7a51faf1.mp4";